import { render, staticRenderFns } from "./TopAlbums.vue?vue&type=template&id=08dd69ce"
import script from "./TopAlbums.vue?vue&type=script&lang=js"
export * from "./TopAlbums.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports